import { render, staticRenderFns } from "./OfferCodeTableItem.vue?vue&type=template&id=5cd96f28&"
import script from "./OfferCodeTableItem.vue?vue&type=script&lang=js&"
export * from "./OfferCodeTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports